import React from "react";
import {FormattedMessage} from "react-intl";
import "../styles/SuccessDialog.css";
import {ReactComponent as SuccessIcon} from "../image/success-icon.svg";

interface SuccessDialogProps {
    titleId: string;
    descriptionId: string;
    buttonId: string;
    onConfirm: () => void;
    values?: Record<string, React.ReactNode>;
    buttonClassName?: string;
}

export function SuccessDialog({
    titleId,
    descriptionId,
    buttonId,
    onConfirm,
    values,
    buttonClassName,
}: SuccessDialogProps) {
    return (
        <div className="success-dialog">
            <div className="success-icon">
                <SuccessIcon />
            </div>

            <h2 className="success-title">
                <FormattedMessage id={titleId} />
            </h2>

            <p className="success-description">
                <FormattedMessage id={descriptionId} values={values} />
            </p>

            <button
                type="button"
                className={`primary-button ${buttonClassName ?? ""}`}
                onClick={onConfirm}
            >
                <FormattedMessage id={buttonId} />
            </button>
        </div>
    );
}
